import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import TermsOfServicePage from "@/pages/TermsOfServicePage";

export const Route = createFileRoute("/terms-of-service")({
  head: () => pageHead("Terms of Service", "AKIVA terms of service - Legal terms and conditions for using our services and website.", "/terms-of-service", false),
  component: TermsOfServicePage,
});
